<template>
  <v-chip
    v-bind="$attrs"
    :small="small"
    :class="statusTextColor"
    :color="statusColor"
    v-on="$listeners"
  >
    {{ statusTitle }}
  </v-chip>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { StatusOption } from '@/types/common';

export default defineComponent({
  name: 'CfsChipStatus',
  props: {
    value: {
      type: null as unknown as PropType<string | null>,
      required: true,
    },
    options: {
      type: Object as PropType<Record<string, StatusOption>>,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    requiredOption: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const statusColor = computed(() => {
      return props.options[props.value]?.color ?? '#FFFFFF00';
    });
    const statusTitle = computed(() => {
      return props.options[props.value]?.title ?? (props.requiredOption ? '---' : props.value);
    });
    const statusTextColor = computed(() => {
      return props.options[props.value]?.textColor ?? 'text-shaft';
    });
    return { statusColor, statusTitle, statusTextColor };
  },
});
</script>
